export function BiscuitiLogo({ size = 28 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 28 28" fill="none" aria-hidden="true" className="shrink-0">
      <rect width="28" height="28" rx="9" fill="url(#bc-grad)" />
      <defs>
        <linearGradient id="bc-grad" x1="0" y1="0" x2="14" y2="28" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#D29A45" />
          <stop offset="100%" stopColor="#B07423" />
        </linearGradient>
      </defs>
      <circle cx="10" cy="11" r="2" fill="#5C3A12" />
      <circle cx="18" cy="17" r="2" fill="#5C3A12" />
      <circle cx="10" cy="19" r="1.75" fill="#5C3A12" />
      <circle cx="18" cy="9" r="1.75" fill="#5C3A12" />
      <rect x="0" y="0" width="28" height="4" rx="9" fill="rgba(255,255,255,.18)" />
    </svg>
  );
}
